module.exports = __webpack_public_path__ + "img/icon_qiuzhi03.232f0ff0.png";